import clsx from "clsx";
import type { DetailedHTMLProps, HTMLAttributes } from "react";

const SectionContainer = ({
	className,
	children,
	...props
}: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>) => {
	return (
		<section
			className={clsx(
				`mx-auto scroll-m-16 px-8 py-8 sm:px-7 sm:py-16 lg:px-16 xl:pt-12 xl:pb-16`,
				className,
			)}
			{...props}
		>
			{children}
		</section>
	);
};

export default SectionContainer;
